import {
  BANKDATA_LOADING,
  GET_BANKDATA,
  GET_BANKDATA_SUCCESS,
  GET_BANKDATA_FAIL,
  ADD_BANKDATA_SUCCESS,
  ADD_BANKDATA_FAIL,
  DELETE_BANKDATA_SUCCESS,
  DELETE_BANKDATA_FAIL,
  UPDATE_BANKDATA_SUCCESS,
  UPDATE_BANKDATA_FAIL
} from "./actionType";

const INIT_STATE = {
  bankDatas: [],
  error: {},
};

const BankData = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BANKDATA_SUCCESS:
      switch (action.payload.actionType) {
        case GET_BANKDATA:
          return {
            ...state,
            bankDatas: action.payload.data,
            isBankDataCreated: false,
            isBankDataSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_BANKDATA_FAIL:
      switch (action.payload.actionType) {
        case GET_BANKDATA_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isBankDataCreated: false,
            isBankDataSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_BANKDATA: {
      return {
        ...state,
        isBankDataCreated: false,
        loading: true,
      };
    }

    case BANKDATA_LOADING: {
      return {
        ...state,
        isBankDataCreated: false,
        loading: true,
      };
    }

    case ADD_BANKDATA_SUCCESS:
      return {
        ...state,
        isBankDataCreated: true,
        loading: false,
        bankDatas: [action.payload.data, ...state.bankDatas],
      };

    case ADD_BANKDATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_BANKDATA_SUCCESS:
      return {
        ...state,
        loading: false,
        bankDatas: state.bankDatas.filter(
          bankData => bankData.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_BANKDATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_BANKDATA_SUCCESS:
      return {
        ...state,
        loading: false,
        bankDatas: state.bankDatas.map(bankData =>
          bankData.id.toString() === action.payload.data.id.toString() ? { ...bankData, ...action.payload.data } : bankData
        ),
      };

    case UPDATE_BANKDATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};

export default BankData;